// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"58089944","160":"3fd9c78f","208":"58e983f3","293":"e26e8611","516":"af088bfc","519":"cd3f8a00","917":"df623c2b","946":"41b194bf"}[chunkId] + ".chunk.js";
};